import React, { useRef } from 'react';
import { useMask } from '@react-input/mask';

const TestMask = () => {
  const inputRef = useRef(null);
  useMask({ ref: inputRef, mask: '_____-___', replacement: { _: /\d/ } });

  return <input ref={inputRef} />;
};

export default TestMask;
